export default {
  general: {
    name: 'Project Flow Administration',
    yes: 'Yes',
    no: 'No',
    add: 'Add',
    update: 'Update',
    close: 'Close',
    cancel: 'Cancel',
    create: 'Create',
    remove: 'Delete',
    confirmation: 'Confirmation',
    search: 'Search',
    language: 'Language',
    validate: 'Validate',
    connect: 'Connect',
    welcome: 'Welcome {name}',
    loading: 'Loading... Please wait',
    loadingShort: 'Loading...',
    empty: 'Empty',
    actions: 'Actions',
    average: 'Average',
    open: 'Open',
    logo: '/images/logo-simple.png',
    restore: 'Restaurer',
    none: 'None',
    export: 'Export',
  },
  date: {
    date: 'MM/dd/yyyy',
    time: 'hh:mm aaaa',
    dateAndTime: 'MM/dd/yyyy \'at\' hh:mm aaaa',
    monthList: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Spetembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
  },
  menu: {
    home: 'Home',
    users: 'Users',
    profile: 'Account',
    logout: 'Logout',
    params: 'Parameters',
    admin: 'Administration',
    tokens: 'Jetons',
    mycompany: 'Organisation',
    companies: 'Instances',
  },
  title: {
    home: 'Home',
    userAccount: 'My account',
  },
  user: {
    company: 'Company',
    login: 'Username',
    password: 'Password',
    changePassword: 'New passowrd',
    confirmPassword: 'Confirmation',
    roles: 'Roles',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'E-mail',
    roleList: {
      OWNER: {
        name: 'Super administrator',
        detail: 'Tous les droits, y compris la gestion des instances clients',
      },
      ADMIN: {
        name: 'Administration',
        detail: 'Gestion de l\'organisation et de ses utilisateurs',
      },
      PARAMS: {
        name: 'Settings',
        detail: 'Gestion de la configuration des jeux',
      },
      COACH: {
        name: 'Training',
        detail: 'Création et animation des sessions de jeux',
      },
    },
    accountUpdated: 'Votre compte a bien été mis à jour',
    userCreated: 'L\'utilisateur a bien été créé',
    userUpdated: 'L\'utilisateur a bien été mis à jour',
    title: {
      userList: 'Liste des utilisateurs',
      createUser: 'Création d\'un utilisateur',
      updateUser: 'Modification d\'un utilisateur',
      restoreUser: 'Gestion des utilisateurs supprimés',
    },
    remove: {
      cantRemoveCurrentUser: 'Vous ne pouvez pas supprimer votre compte.',
      message: '| Souhaitez-vous supprimer l\'utilisateur sélectionné ? | Souhaitez-vous supprimer les {count} utilisateurs sélectionnés ?',
      success: '| L\'utilisateur a bien été supprimé. | Les {count} utilisateurs ont bien été supprimés.',
    },
    restore: {
      confirm: '| Souhaitez-vous restaurer cet utilisateur ? | Souhaitez-vous restaurer les {count} utilisateurs ?',
      success: '| L\'utilisateur a bien été restauré | Les {count} utilisateurs ont bien été restaurés',
      noRemovedUser: 'Aucun utilisateur n\'a été supprimé',
    },
  },
  company: {
    title: {
      companyList: 'Gestion des instances',
      createCompany: 'Création d\'une instance',
      trainedPlayerChart: 'Nombre de participants par mois',
      addToken: 'Ajouter des jetons',
      restoreCompany: 'Gestion des instances supprimées',
    },
    menu: {
      general: 'Informations générales',
      demands: 'Demandes de jetons',
      history: 'Historique',
      users: 'Utilisateurs',
      addTokenButton: 'Ajouter des jetons',
      restoreCompanyButton: 'Gestion des instances supprimées',
    },
    fields: {
      companyLogin: 'Identifiant',
      displayName: 'Nom',
      companyContact: 'Contact',
      logo: 'Logo',
      tokenBalance: 'Solde de jetons',
      masterContactList: 'Contact Agilea',
      activeTokenDemandNumber: 'Nombre de demandes en cours',
      lastSessionDateCreation: 'Dernière session',
      duplicateCompanyId: 'Instance à dupliquer',
    },
    addToken: {
      fields: {
        demand: 'Demande liée',
        tokenNumber: 'Nombre de jetons',
        label: 'Libéllé',
        bill: 'Facture (factultatif)',
      },
      demandFieldEmpty: 'Aucune',
      demandItemLabel: '| Demande de 1 jeton par {firstName} {lastName} (le {date}) | Demande de {token} jetons par {firstName} {lastName} (le {date})',
      success: 'Les jetons ont bien été ajoutés',
    },
    demands: {
      addTokenButton: 'Ajouter des jetons',
      changeToDoneButton: 'Marquer la demande comme traitée',
      changeToDoneSuccess: 'La demande est maintenant traitée',
    },
    history: {
      balance: 'Aucun jeton disponible | 1 jeton disponible | {balance} jetons disponibles',
    },
    remove: {
      confirm: '| Souhaitez-vous supprimer cette instance ? | Souhaitez-vous supprimer les {count} instances ?',
      success: '| L\'instance a bien été supprimée | Les {count} instances ont bien été supprimées',
      cantRemoveMaster: 'Impossible de supprimer une instance maître',
    },
    realRemove: {
      confirm: '| Souhaitez-vous supprimer définitivement cette instance ? Cette action est irréversible ! | Souhaitez-vous supprimer définitivement les {count} instances ? Cette action est irréversible !',
      success: '| L\'instance a bien été supprimée définitivement | Les {count} instances ont bien été supprimées définitivement',
    },
    restore: {
      confirm: '| Souhaitez-vous restaurer cette instance ? | Souhaitez-vous restaurer les {count} instances ?',
      success: '| L\'instance a bien été restaurée | Les {count} instances ont bien été restaurées',
    },
    myCompanyUpdated: 'Votre organisation a bien été mise à jour',
    companyUpdated: 'L\'organisation a bien été mise à jour',
    companyCreated: 'L\'organisation a bien été créée',
    noLastSessionDateCreation: 'Aucune session ouverte',
    emptyTrainedPlayerChart: 'Aucune session n\'a été lancée sur les 12 derniers mois',
    noRemovedCompany: 'Aucune instance n\'a été supprimée',
  },
  error: {
    api: {
      UserLoginDoesntExistError: 'User and/or password are not correct.',
      PasswordDoesntMatchError: 'User and/or password are not correct.',
      UserDeletedError: 'User has been deleted from the game.',
      CompanyNotFoundError: 'The organization does not exist.',
      UnexpectedError: 'An error occured.',
      Forbidden: 'You are not allowed to achieve this task.',
      CreateUserLoginTakenError: 'L\'identifiant existe déjà dans votre organisation.',
      EditUserLoginTakenError: 'The user already exists in the organization.',
      DrawConfigurationNameLessThanMinError: 'The configuration name is too short.',
      VersionNameLessThanMinError: 'The name of the game is too short.',
      NetworkError: 'Impossible to connect to the server.',
      UnknownError: 'An unknown error occured.',
      'Not Found': 'An unknown error occured. (404)',
    },
    form: {
      required: 'The field is required',
      minLength: 'The field must contain at least {length} characters.',
      maxLength: 'The field can not contain more than {length} characters.',
      noSpaces: 'The filed can not contain empty spaces',
      noEqualPassword: 'Passwords are not the same',
      userExist: 'User already exists',
      companyExist: 'L\'identifiant d\'organisation est déjà utilisé',
      alpha: 'The field must contain letters',
      greater: 'The figure must be superior to {number}',
      lower: 'The figure must be inferior to {number}',
      email: 'L\'adresse e-mail n\'est pas valide',
      integer: 'Le nombre doit être entier',
    },
  },
  language: {
    french: 'French',
    english: 'English',
  },
  color: {
    red: 'Red',
    pink: 'Pink',
    purple: 'Purple',
    'deep-purple': 'Dark Purple',
    indigo: 'Indigo',
    blue: 'Blue',
    'light-blue': 'Light blue',
    cyan: 'Cyan',
    teal: 'Teal',
    green: 'Green',
    'light-green': 'Lime Green',
    lime: 'Lemon',
    yellow: 'Yellow',
    amber: 'Amber',
    orange: 'Orange',
    'deep-orange': 'Dark Orange',
    brown: 'Brown',
    'blue-grey': 'Dark Blue',
    grey: 'Grey',
  },
  multiproject: {
    menu: {
      main: 'Multi-projects',
      versions: 'Versions',
      draws: 'Resources drawings',
    },
    title: {
      createDraw: 'Create a new drawing',
      updateDraw: 'Modify a drawing',
      createVersion: 'Create a new version of the Multi-Projects game',
      updateVersion: 'Modify a multi-projects game',
      projectNames: 'Name of the projects',
      ressourceNames: 'Name of the resources',
    },
    fields: {
      draw: {
        name: 'Name',
        type: 'Type',
        defaultDraw: 'Default',
        round: 'Round',
        blue: 'Blue',
        green: 'Green',
        yellow: 'Yellow',
        red: 'Red',
        variability: 'Variability',
        relatedDraw: 'Related flux project draw',
        typeList: {
          standard: 'Standard',
          ccpm: 'Flux',
        },
      },
      version: {
        name: 'Name of the game',
        default: 'Default',
        projectName: 'Name of the project N°{index}',
        blue: 'Name of the blue resource',
        green: 'Name of the green resource',
        yellow: 'Name of the yellow resource',
        red: 'Name of the red resource',
      },
      error: {
        between: 'Must be between {min} and {max}',
      },
      success: {
        drawCreated: 'The configuration of the drawing has been created.',
        drawUpdated: 'The configuration of the drawing has been updated.',
        versionCreated: 'The version of the multi-projects game has been created',
        versionUpdated: 'The version of the multi-projects game has been updated',
      },
    },
    remove: {
      message: '| Do you want to delete this drawing ? | Do you want to delete the {count} drawings configurations ?',
      success: '| The drawing has been deleted | The {count} drawings configurations have been deleted.',
      cantRemoveDefaultDraw: 'Impossible to delete the default\'s drawings configuration',
      messageVersion: '| Souhaitez-vous supprimer cette version du jeu multi-projet ? | Souhaitez-vous supprimer les {count} versions du jeu multi-projet ?',
      successVersion: '| La version du jeu multi-projet a été supprimée | Les {count} versions du jeu multi-projet ont bien été supprimées',
      cantRemoveDefaultVersion: 'Impossible de supprimer une version du jeu multi-projet par défaut',
    },
    template: {
      download: 'Télécharger un template',
      upload: 'Charger le template',
      uploadSuccess: 'Chargement du template terminé',
      uploadError: 'Erreur lors du chargement du template',
      uploadErrorLength: 'Le template doit contenir extactement 100 tirages',
    },
  },
  multitask: {
    title: {
      main: 'Multitâches',
    },
    menu: {
      main: 'Multitâches',
    },
    fields: {
      settings: {
        lengthOfChoiceList: 'Nombre de combinaisons à réaliser',
        mistakePenality: 'Temps de pénalité en cas d\'erreur',
      },
      success: {
        settingsUpdated: 'Les paramètres ont bien été modifiés',
      },
    },
  },
  networkdiagram: {
    title: {
      main: 'Gamme projet',
      createInstruction: 'Créer une instruction',
    },
    menu: {
      main: 'Gamme projet',
    },
    fields: {
      instruction: {
        upload: 'Cliquez ou glissez une image dans la zone pour créer une nouvelle instruction',
      },
      success: {
        instructionCreated: 'L\'instruction a bien été créée',
        instructionUpdated: 'Les instructions ont bien été modifiées',
      },
    },
    remove: {
      message: '| Souhaitez-vous supprimer cette instruction ? | Souhaitez-vous supprimer les {count} instructions ?',
      success: '| L\'instruction a été supprimée | Les {count} instructions ont bien été supprimées',
    },
  },
  ontime: {
    title: {
      versionList: 'Liste des versions du jeu de l\'estimation du temps',
      createVersion: 'Création d\'une version du jeu de l\'estimation du temps',
      updateVersion: 'Modification d\'une version du jeu de l\'estimation du temps',
    },
    menu: {
      main: 'Estimation temps',
    },
    fields: {
      version: {
        name: 'Nom',
        default: 'Défaut',
        questionOne: 'Question 1',
        questionTwo: 'Question 2',
      },
      success: {
        versionCreated: 'La version a bien été créée',
        versionUpdated: 'La version a bien été modifiée',
      },
    },
    remove: {
      messageVersion: '| Souhaitez-vous supprimer cette version du jeu de l\'estimation du temps ? | Souhaitez-vous supprimer les {count} versions du jeu de l\'estimation du temps ?',
      cantRemoveDefaultVersion: 'Impossible de supprimer cette version du jeu de l\'estimation du temps',
      successVersion: '| La version du jeu de l\'estimation du temps a été supprimée | Les {count} versions du jeu de l\'estimation du temps ont bien été supprimées',
    },
  },
  player: {
    title: {
      playerList: 'Liste des participants',
    },
    menu: {
      main: 'Participants',
    },
    fields: {
      session: {
        name: 'Session',
        dateCreate: 'Créée le',
        userCreate: 'Créée par',
        language: 'Langue',
      },
      player: {
        name: 'Nom Prénom',
        email: 'E-mail',
      },
    },
    export: {
      sheetname: 'Participants',
      filename: 'Liste des participants',
    },
  },
  trainingsession: {
    title: {
      main: 'Liste des sessions',
      createSession: 'Créer une session',
    },
    menu: {
      main: 'Créer une session',
    },
    remove: {
      confirm: '| Souhaitez-vous supprimer cette session de jeu ? | Souhaitez-vous supprimer les {count} sessions de jeu ?',
      success: '| La session de jeu a bien été supprimée | Les {count} versions de jeu ont bien été supprimées',
      refundToken: '| Vous allez récupérer 1 jeton suite à cette suppression. | Vous allez récupérer {tokenToRefunds} jetons suite à cette suppression.',
    },
    token: {
      balance: '| Vous avez 1 jeton disponible | Vous avez {balance} jetons disponibles',
      emptyBalance: 'Vous n\'avez plus de jetons disponibles pour créer une session',
      goToDemandPage: 'Demander de nouveaux jetons',
    },
    fields: {
      status: {
        created: 'Créée',
        opened: 'Ouverte',
        closed: 'Fermée',
      },
      session: {
        name: 'Nom',
        code: 'Code',
        userCreate: 'Créée par',
        dateCreate: 'Créée le',
        status: 'Statut',
        nbPlayer: 'Nombre de participants',
        player: 'Participants',
      },
      multiproject: {
        title: 'Multi-projets',
        versionId: 'Version',
        nbProject: 'Nombre de projets',
        standardDrawId: 'Tirage standard',
        ccpmDrawId: 'Tirage CCPM',
        nbProjectWarning: 'Pensez à saisir le nombre de projets',
      },
      multitask: {
        title: 'Multitâches',
        lengthOfChoiceList: 'Nombre de combinaisons à réaliser',
        mistakePenality: 'Temps de pénalité en cas d\'erreur',
      },
      networkdiagram: {
        title: 'Gamme projet',
      },
      ontime: {
        title: 'Estimation du temps',
        versionId: 'Version',
        versionWarning: 'Pensez à choisir une version',
      },
      criticalchain: {
        title: 'Chaîne critique',
      },
      actions: {
        button: 'Animer',
      },
      success: {
        sessionCreated: 'La session a bien été créée',
      },
    },
  },
  tokens: {
    title: {
      createDemands: 'Demande de jetons',
      viewDemands: 'Demande de jetons',
    },
    menu: {
      main: 'Gestion des jetons',
      history: 'Historique',
      demands: 'Demandes',
      askTokenButton: 'Demander des jetons',
    },
    balance: 'Vous n\'avez plus de jeton disponible | Vous avez 1 jeton disponible | Vous avez {balance} jetons disponibles',
    history: {
      fields: {
        date: 'Date',
        label: 'Libellé',
        type: 'Type',
        tokenNumber: 'Quantité',
        bill: 'Facture',
        sessionLabel: 'Session : {label}',
      },
      type: {
        consumption: {
          label: 'Utilisation',
          color: 'amber',
        },
        purchase: {
          label: 'Achat',
          color: 'green',
        },
        refund: {
          label: 'Remboursement',
          color: 'teal',
        },
        other: {
          label: 'Autre',
          color: 'indigo',
        },
      },
    },
    demands: {
      fields: {
        creationDate: 'Date',
        createdBy: 'Demandeur',
        status: 'Statut',
        tokenNumber: 'Nombre de tokens',
        comment: 'Détail sur la demande',
      },
      status: {
        inProgress: {
          label: 'En cours',
          color: 'info',
        },
        done: {
          label: 'Validée',
          color: 'accent',
        },
        cancel: {
          label: 'Annulée',
          color: 'warning',
        },
      },
      success: 'Votre demande a bien été envoyée !',
      cancelConfirm: 'Voulez-vous annuler cette demande de jetons ?',
      cancelSuccess: 'La demande a bien été annulée',
      cancelError: 'Erreur lors de la demande d\'annulation',
    },
  },
  animation: {
    title: {
      addSession: 'Ajouter des sessions',
      noSession: 'Aucune session en cours !',
    },
    menu: {
      main: 'Animer une session',
      right: {
        addsession: 'Ajouter des sessions',
      },
      buttons: {
        play: 'Relancer le jeu',
        pause: 'Mettre en pause',
        open: 'Ouvrir',
        close: 'Clôturer',
        reopen: 'Réouvrir',
      },
      games: {
        multiProjectStandard: 'Multi-projets Standard',
        multiProjectCcpm: 'Multi-projets CCPM',
        multiTaskParallel: 'Multitâche',
        multiTaskSequential: 'Monotâche',
        networkDiagramWithoutInstructions: 'Gamme projet sans instruction',
        networkDiagramWithInstructions: 'Gamme projet avec instructions',
        onTime: 'Estimation du temps',
        criticalChain: 'Chaîne critique',
      },
      players: 'Participants',
      session: {
        play: {
          success: 'La session est bien sortie du mode pause',
          error: 'Erreur lors de la sortie de la session du mode pause',
        },
        pause: {
          success: 'La session a bien été mise en pause',
          error: 'Erreur lors de la mise en pause de la session',
        },
        opened: {
          confirmMessage: 'Êtes-vous sur de vouloir ouvrir cette session ?',
          confirmButton: 'Ouvrir',
          success: 'La session a bien été ouverte',
          error: 'Erreur lors de l\'ouverture de la session',
        },
        closed: {
          confirmMessage: 'Êtes-vous sur de vouloir clôturer cette session ?',
          confirmButton: 'Clôturer',
          success: 'La session a bien été fermée',
          error: 'Erreur lors de la fermeture de la session',
        },
        reopened: {
          confirmMessage: 'Êtes-vous sur de vouloir ouvrir à nouveau cette session ?',
          confirmButton: 'Ouvrir',
        },
      },
      game: {
        opened: {
          confirmMessage: 'Êtes-vous sur de vouloir démarrer ce jeu ?',
          confirmButton: 'Démarrer',
          success: 'Le jeu a bien été démarré',
          error: 'Erreur lors du démarrage du jeu',
        },
        finished: {
          confirmMessage: 'Êtes-vous sur de vouloir terminer ce jeu ?',
          confirmButton: 'Terminer',
          success: 'Le jeu a bien été terminé',
          error: 'Erreur lors de la fermeture du jeu',
        },
      },
    },
    error: {
      emptyAddSession: 'Aucune session n\'est disponible à l\'ouverture',
      noResultAddSession: 'Aucune session correspondante trouvée',
    },
    message: {
      closeSession: 'Êtes-vous sur de vouloir fermer cette session ?',
      noSession1: 'Pour animer votre formation, vous devez commencer par ouvrir la ou les sessions souhaitées.',
      noSession2: 'Pour cela ouvrez le panneau de droite et cliquer sur ajouter des sessions.',
    },
    players: {
      title: 'Liste des participants : {sessionCode}',
      fields: {
        playerCode: 'Code',
        sessionCode: 'Code session',
        name: 'Nom',
        email: 'Mail',
        connected: 'Connecté',
      },
      socket: {
        login: 'Un participant vient de se connecter',
        logout: 'Un participant vient de se déconnecter',
      },
      export: {
        sessionName: 'Session',
        sessionCode: 'Code session',
        sessionDateCreate: 'Créée le',
        playerCode: 'Code participant',
        playerName: 'Nom Prénom',
        playerEmail: 'E-mail',
        sheetname: 'Session {name}',
        filename: 'Liste des participants - {name}',
      },
    },
    multiproject: {
      general: {
        start: 'Début',
        end: 'Fin',
        planned: 'Prévu',
        real: 'Réel',
        weekFirstLetter: 'S',
        averageFirstLetter: 'M',
        demandFirstLetter: 'D',
        projectDone: 'Terminé en {duration} semaines',
        numberChanges: 'sans changement de date de fin | avec {changes} changement de date de fin | avec {changes} changements de date de fin',
        auto: 'Joueur Auto',
        round: 'Tour | Tour | Tours',
        noHistory: 'Aucun changement',
        notPlayerName: 'Non connecté',
        draw: 'Tirages',
        feverchart: 'Fever Chart',
        confirm: {
          enableModeAuto: 'Etes-vous sur de vouloir passer le joueur {name} en mode automatique ? Il ne pourra plus participer au jeu tant que ce mode est activé.',
          disableModeAuto: 'Etes-vous sur de vouloir passer à nouveau le joueur {name} en mode manuel pour qu\'il reprenne la partie en cours ?',
        },
      },
      status: {
        notReady: {
          message: 'Le joueur n\'est pas encore prêt.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        waitForStart: {
          message: 'Prêt à jouer. En attente des autres participants.',
          icon: 'mdi-check-circle-outline',
          color: 'success',
        },
        readyToStartGame: {
          message: 'Le joueur va démarrer le jeu.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        cantStartProject: {
          message: 'Le joueur est en attente. Son projet ne peut pas encore démarrer.',
          icon: 'mdi-check-circle-outline',
          color: 'success',
        },
        mustStartProject: {
          message: 'Le joueur doit démarrer son projet ce tour.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        canStartProjectBlueReady: {
          message: 'Le joeur peut démarrer sont projet suite à la disponibilité de la ressource bleu.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        resourcesSelection: {
          message: 'Le joueur sélectionne ces ressources pour le tour en cours.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        waitForResourcesCapacity: {
          message: 'Le joueur est en attente de reçevoir les ressources demandées.',
          icon: 'mdi-check-circle-outline',
          color: 'success',
        },
        canGetCapacity: {
          message: 'Le joueur doit récuéprer les ressources qui lui sont attribuées.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        canStartProjectBlueOverCapacity: {
          message: 'Le joueur peut démarrer sont projet suite à un exédent de bleu sur le projet précédent.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        capacityReceived: {
          message: 'Le joueur doit mettre à jour son gantt avec les ressources disponibles.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        mustChangeEndDate: {
          message: 'La date prévisionnelle de fin de projet est atteinte et le joueur doit la changer.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        waitToStartNewWeek: {
          message: 'Le joueur est en attente de la fin de la semaine actuelle.',
          icon: 'mdi-check-circle-outline',
          color: 'success',
        },
        readyToStartNewWeek: {
          message: 'Le joueur doit démarrer une nouvelle semaine sur son projet.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        readyToStartNewWeekProjectNotStarted: {
          message: 'Le joueur doit démarrer une nouvelle semaine mais son projet n\'est pas encore lancé.',
          icon: 'mdi-alert-circle-outline',
          color: 'error',
        },
        projectFinished: {
          message: 'Le joueur a terminé son projet.',
          icon: 'mdi-check-circle-outline',
          color: 'success',
        },
      },
      notification: {
        allPlayersReady: 'Tous les joueurs sont prêts. Lancement du jeu.',
      },
      draw: {
        title: 'Liste des tirages du jeu',
        success: 'La liste des tirages a bien été modifiée',
      },
      criticalResource: {
        title: 'Sélection de la ressource critique',
        confirmButton: 'Valider le choix de la ressource critique',
        confirmMessage: 'Voulez vous vraiment utiliser la ressource {name} en tant que ressource critique sur ces projets ?',
        success: 'La ressource critique a bien été sélectionnée',
      },
      feverchart: {
        title: 'Fever Chart',
        mono: 'Mono',
        multi: 'Multi',
        progress: 'Avancement',
        buffer: 'Buffer',
      },
    },
    multitask: {
      timePlayed: '| {timePlayed} seconde | {timePlayed} secondes',
      numberOfMistakes: 'Aucune erreur | {numberOfMistakes} erreur | {numberOfMistakes} erreurs',
      restartGame: 'Relancer',
      notPlayerName: 'Non connecté',
      timeChartTitle: 'Temps',
      mistakesChartTitle: 'Erreurs',
      status: {
        ready: 'Prêt à jouer',
        playing: 'Partie en cours',
      },
    },
    networkdiagram: {
      notPlayerName: 'Non connecté',
      instructionStep: 'Instruction {current}/{total}',
      finishGame: {
        button: 'Mettre fin au jeu',
        message: 'Souhaitez-vous mettre fin au jeu pour tous les participants ?',
      },
      status: {
        ready: 'Prêt à jouer',
        playing: 'Partie en cours depuis\n{seconds} secondes | Partie en cours depuis\n{minutes} minute et {seconds} secondes | Partie en cours depuis\n{minutes} minutes et {seconds} secondes',
        finished: 'Résultat obtenu en\n{seconds} secondes | Résultat obtenu en\n{minutes} minute et {seconds} secondes | Résultat obtenu en\n{minutes} minutes et {seconds} secondes',
        noPlayed: 'Le joueur n\'a pas joué',
      },
    },
    ontime: {
      notPlayerName: 'Non connecté',
      questionOne: 'Question 1',
      questionTwo: 'Question 2',
      noAnswered: 'En cours',
      answers: 'Réponses',
      nextQuestion: {
        button: 'Question suivante',
        message: 'Souhaitez-vous passer à la question suivante pour tous les participants ?',
      },
      choiceList: {
        'day-before': 'La veille',
        '00:00': '00:00',
        '00:30': '00:30',
        '01:00': '01:00',
        '01:30': '01:30',
        '02:00': '02:00',
        '02:30': '02:30',
        '03:00': '03:00',
        '03:30': '03:30',
        '04:00': '04:00',
        '04:30': '04:30',
        '05:00': '05:00',
        '05:30': '05:30',
        '06:00': '06:00',
        '06:30': '06:30',
        '07:00': '07:00',
        '07:30': '07:30',
        '08:00': '08:00',
        '08:30': '08:30',
        '09:00': '09:00',
        '09:30': '09:30',
      },
    },
    criticalchain: {
      notPlayerName: 'Non connecté',
      unselectedCardMessage: 'Cliquez sur la carte d\'un participant pour consulter son gantt',
      selectedPlayer: 'Gantt de {playerName}',
      buffer: 'Buffer ({size})',
      bufferNotDefined: 'A définir',
      status: {
        ready: 'Prêt à jouer',
        canRemoveMultiTask: 'Multi-tâche',
        canSelectCriticalChain: 'Chaîne critique',
        canDefineBufferSize: 'Taille du buffer',
        finished: 'Terminé',
      },
    },
  },
}
